import * as React from 'react';
import { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';

interface BlockProps {
  title?: string;
  children?: React.ReactNode;
}

export const Block = (props: BlockProps): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <div className={'grid'}>
      {props.title && <h2 className={'col-12 mb-0 mt-2'}>{intl.formatMessage({id: props.title})}</h2>}
      {props.children}
    </div>
  );
};
